const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="relative flex items-center justify-between border-t border-[#d4af37]/20 px-6 py-10 md:px-12"
  >
    <span
      className="font-serif-display text-sm uppercase text-[#f3ead6]/50"
      style={{ letterSpacing: "0.3em" }}
    >
      Amrita Sen
    </span>
    <a
      data-testid="footer-contact-link"
      href="https://www.amritasen.com/amrita-sen-contact.html"
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs uppercase text-[#a89a80] transition-colors duration-500 hover:text-[#d4af37]"
      style={{ letterSpacing: "0.3em" }}
    >
      Contact
    </a>
  </footer>
);

export default SiteFooter;
